import {alignStart, dFlex, flexColumn} from '../../../../../globalVariables/GlobalFlex';
import WindowTemplate from '../../WindowTemplate/windowTemplate';

const gridMoreStyle = `                  
    ${dFlex}
    ${flexColumn}
    ${alignStart}
`;
const settings = [
    {
        gridArea: 'title',
        width: '50px',
        height: '18px'
    },
    {
        gridArea: 'amount',
        width: '65px',
        height: '31px'
    },
    {
        gridArea: 'subtext', 
        width: '160px',
        height: '16px',
    },
];

function ArrivalConfirmationChartTemplate() {
   
    return <WindowTemplate gridMoreStyle={gridMoreStyle} gridAreas={''} settings={settings} />;

}
export default ArrivalConfirmationChartTemplate;